import React from 'react';
import { useSet } from 'react-use';
import { Accordion } from '../../../../../CommonComponents/OPL/Accordion/Accordion/Accordion';
import { AccordionButton } from '../../../../../CommonComponents/OPL/Accordion/AccordionButton/AccordionButton';
import { ModelGroupActions } from '../ModelGroupActions/ModelGroupActions';
import { AccordionPanel } from '../../../../../CommonComponents/OPL/Accordion/AccordionPanel/AccordionPanel';
import { ModelGroup } from '../ModelGroup/ModelGroup';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ModelGroupDTO, useModelGroupsQuery } from '../../api/useModelGroupsQuery';
import { ModelGroupsLoading } from './ModelGroups.loading';

interface Props {
  setModelGroupToEdit(group: ModelGroupDTO): void;
}

export const ModelGroups: React.FC<Props> = ({ setModelGroupToEdit }) => {
  const [, { has, toggle }] = useSet<string>();

  const { isFetching, data } = useModelGroupsQuery();

  if (isFetching) {
    return <ModelGroupsLoading />;
  }

  if (!data) {
    return null;
  }

  const { modelPortfoliosGroups } = data;

  return (
    <Box mt="24" maxWidth={800} minWidth={600}>
      {modelPortfoliosGroups.map(modelGroup => {
        const { groupName, groupId, modelPortfolios } = modelGroup;

        const buttonId = `button-${groupId}`;
        const panelId = `panel-${groupId}`;
        const isActive = has(groupId);

        return (
          <Accordion key={groupId} isActive={isActive} mb="16">
            <AccordionButton
              id={buttonId}
              panelId={panelId}
              isActive={isActive}
              onClick={() => {
                toggle(groupId);
              }}
              extra={
                <ModelGroupActions
                  isActive={isActive}
                  onEdit={() => setModelGroupToEdit(modelGroup)}
                />
              }
            >
              {groupName}
            </AccordionButton>

            <AccordionPanel id={panelId} buttonId={buttonId} isActive={isActive}>
              <ModelGroup isReadonly modelGroup={modelGroup} models={modelPortfolios} />
            </AccordionPanel>
          </Accordion>
        );
      })}
    </Box>
  );
};
